
























































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import VoucherTemplateVue from "../components/VerifyVoucher/VoucherTemplate.vue";
import { ProviderArr } from "@/data/BusinessTypes";
import { DepartArray } from "@/data/DepartList";
import { Providers } from "@/data/BusinessTypes";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "voucher-template": VoucherTemplateVue,
    }
})
export default class VerifyVATInvoice extends Vue {
    searchQuery: string = "";  //搜索内容、
    shouldFetch: boolean = false; // 展示凭证
    checkAll: boolean = false;
    voucherTemplate: boolean = false;
    isMulti: boolean = false;
    cate: number = 1;
    curItem: Invoice.Invoice | string = "";
    checkedInvoices: Invoice.Invoice[] = [];
    filterVisible: boolean = false;
    businessTypeList = Providers;
    businessType: any = "";
    resetFilter() {
        this.businessType = ""
        this.searchQuery = ""
        this.fetchData();
        this.filterVisible = false;
    }
    confirmFilter() {
        this.fetchData();
        this.filterVisible = false;
    }
    // 分页
    currentPage: number = 1;
    pageSize: number = 20;
    // 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
        this.fetchData();
    }
    totalElements: number = 0;
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
    // 业务类型
    businessTypeArray = ProviderArr;
    // 部门
    departmentArray = DepartArray;
    // 获取数据
    invoiceVoucher: Invoice.Invoice[] = [];
    // 使用模板
    useTp(tp: Journal.Journal) {
        if (!this.isMulti) {
            let curTp = <Invoice.Invoice>this.curItem
            if (curTp.voucherTemplateId != null) curTp.voucherTemplateId = tp.id;
            Vue.axios
                .post(
                    `invoice/update`, this.curItem)
                .then(res => {
                    this.voucherTemplate = false;
                    this.fetchData();
                });
        } else {
            Vue.axios
                .post(
                    `invoice/update/multi`, {
                    invoiceList: this.checkedInvoices,
                    voucherTemplateId: tp.id
                })
                .then(res => {
                    this.voucherTemplate = false;
                    this.checkedInvoices = [];
                    this.fetchData();
                });
        }
        this.isMulti = false;
    }
    fetchData() {
        this.shouldFetch = false;
        Vue.axios
            .post(
                `invoice/templates?page=${this.currentPage - 1}&size=${this.pageSize}`,
                {
                    accountBookId: this.$store.state.accountBook.id,
                    endPeriod: this.period[1],
                    startPeriod: this.period[0],
                    searchKey: this.searchQuery,
                    isProviderOrCustomer: this.purchase ? 0 : 1,
                    businessType: this.businessType ? this.businessType : "",
                }
            )
            .then(res => {
                this.checkAll = this.judgeAllChecked(res.data.invoiceDtos.content);
                this.invoiceVoucher = res.data.invoiceDtos.content;
                this.totalElements = res.data.invoiceDtos.totalElements;
            });
    }
    //改变时间
    period: string[] = []; // 日期
    changeDate(date: string[],) {
        this.period = date;
        this.checkedInvoices = [];
        this.fetchData();
    }
    // 多选
    selectAll(val: boolean) {
        this.invoiceVoucher.forEach((v: any) => {
            v.checked = val;
        })
    }
    // 监听表格数据
    @Watch("invoiceVoucher", { deep: true })
    checkedChange(val: Invoice.Invoice[]) {
        let all = val.length > 0 ? true : false;
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                this.removeElement(val[i]);
            } else {
                if (!this.judgeInclude(val[i])) this.checkedInvoices.push(val[i]);
            }
        }
        this.checkAll = all;
    }
    judgeInclude(v: any) {
        for (let i = 0; i < this.checkedInvoices.length; i++) {
            if (this.checkedInvoices[i].id === v.id) return true;
        }
        return false
    }
    judgeAllChecked(content: any) {
        let all = content.lengthscope > 0 ? true : false;;
        for (let i = 0; i < content.length; i++) {
            let bool = this.judgeInclude(content[i]);
            content[i].checked = bool;
            if (!bool) all = false;
        }
        return all;
    }
    removeElement(v: any) {
        for (let i = 0; i < this.checkedInvoices.length; i++) {
            if (this.checkedInvoices[i].id === v.id) {
                this.checkedInvoices.splice(i, 1);
                break;
            }
        }
    }
    multiTemp() {
        this.cate = this.purchase ? 1 : 2;
        this.curItem = "";
        if (this.checkedInvoices.length === 0) {
            this.isMulti = true;
            this.voucherTemplate = true;
            return;
        }

        let diffs = [],
            firstVoice = this.checkedInvoices[0];
        for (let i = 1; i < this.checkedInvoices.length; i++) {
            let el = this.checkedInvoices[i];
            if (el.isProviderOrCustomer != firstVoice.isProviderOrCustomer) diffs.push(el.voucherNo);
        }

        if (diffs.length === 0) {
            this.isMulti = true;
            this.voucherTemplate = true;
        } else {
            this.$alert(`亲，凭证号为 ${diffs.join(",")} 的发票与其他发票类型不同，请重新勾选`, "温馨提示");
        }
    }
    // 打开凭证
    openTemplate(item: Invoice.Invoice) {
        this.cate = +item.isProviderOrCustomer === 0 ? 1 : 2;
        this.curItem = item;
        this.voucherTemplate = true;
    }
    // 审核增加搜索
    hlInner(con: string) {
        if (this.searchQuery != "") {
            let reg = new RegExp(`${this.searchQuery}`, "gim");
            return con.replace(reg, `<span class="hl">${this.searchQuery}</span>`);
        } else {
            return con
        }
    }
    //销项发票/进项发票切换
    purchase: boolean = true
    changeIncoiceType(index: number) {
        this.checkedInvoices = [];
        if (index == 0) {
            this.businessType = "",
                this.purchase = true;
        } else {
            this.purchase = false;
        }
        this.fetchData();
    }
}
